const style = (theme) => {
  const output = {
    root: {
      width: '100%',
      transform: 'translateZ(0)',
      display: 'inline-flex',
      whiteSpace: 'nowrap',
      position: 'relative',
      marginLeft: '-5%',
    },
    reverse: {
      justifyContent: 'flex-end',
      marginLeft: '5%',
    },
    groupContainer: {
      width: 'auto',
      display: 'inline-flex',
      whiteSpace: 'nowrap',
      position: 'relative',
    },
    railContainer: {
      display: 'flex',
      width: 'auto',
      whiteSpace: 'nowrap',
    },
    railTrack: {
      display: 'inline-block',
    },
    text: {
      lineHeight: '1',
      fontSize: '10vw',
      letterSpacing: '2px',
      display: 'flex',
      alignItems: 'center',
    },
  }

  output[theme.mediaInverse.sm] = {
    text: {
      // fontSize: '14vw',
    },
  }

  return output
}

export default style
